$(function() {

    Fancybox.bind('[data-fancybox]', {
        mainClass: 'event-gallery'
    })
   
})
